import { render, staticRenderFns } from "./LiveStatics.vue?vue&type=template&id=4f4d700c&scoped=true&"
import script from "./LiveStatics.vue?vue&type=script&lang=js&"
export * from "./LiveStatics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d700c",
  null
  
)

export default component.exports